import React, { Component } from "react";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import withRouter from "../../components/withRouter/withRouter";
import ContentBody from "../../components/content/ContentBody";
import InputField from "../../components/inputField/inputField";
import TextEditor from "../../components/textEditor/textEditor";
// import callApi from "../../../Apis/callApi";
// import axios from "axios";
import { toast } from "react-hot-toast";
import { createJob, getJobById, updateJobById } from "../../api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

class AddUpdateJob extends Component {
  state = {
    title: "",
    department: "",
    description: "",
    position: "",
    type: "",
    skils: [],
    skillsText: "",
    experience: "",
    qualification: "",
    salary: "",
    noticePeriod: "",
    location: "",
    workingDays: "",
    shiftTime: "",
    benefits: "",
    hiringProcess: "",
    numberOfOpenings: "",
    loading: false,
    metaDescription: "",
    metaImageUrl: "",
    slug: "",
    metaTitle: "",
    canonicalUrl: "",
  };

  componentDidMount() {
    if (this.props.router.params.id) {
      this.setState({ loading: true });
      this.getData();
    }
  }

  getData = () => {
    getJobById(this.props.router.params.id)
      .then((res) => {
        console.log("Job By Id data :::: ", res.data);
        this.setState({
          title: res.data?.jobTitle,
          department: res.data?.department,
          position: res?.data?.position,
          type: res?.data?.type,
          experience: res?.data?.experince,
          noticePeriod: res?.data?.noticePeriod,
          location: res?.data?.location,
          workingDays: res?.data?.workingDays,
          shiftTime: res?.data?.shiftTimings,
          numberOfOpenings: res?.data?.numberOfOpenings,
          salary: res?.data?.salary,
          skils: res?.data?.skills,
          qualification: res?.data?.qualification,
          benefits: res?.data?.benefits,
          hiringProcess: res?.data?.hiringProcess,
          description: res?.data?.description,
          loading: false,
          metaDescription: res?.data?.metaData?.metaDescription,
          metaImageUrl: res?.data?.metaData?.metaImageUrl,
          metaTitle: res?.data?.metaData?.metaTitle,
          slug: res?.data?.metaData?.slug,
          canonicalUrl: res?.data?.metaData?.canonicalUrl,
        });
      })
      .catch((err) => {});
  };

  validate = () => {
    if (!this.state.title) {
      toast.error("Title is required.");
      return false;
    }

    return true;
  };

  handleSubmit = (event) => {
    if (event.target.name === "btn3") {
      this.props.router.navigate("/jobs");
    } else {
      if (this.validate()) {
        this.setState({ loading: true });
        let data = {
          jobTitle: this.state.title,
          department: this.state.department,
          position: this.state.position,
          type: this.state.type,
          experince: this.state.experience,
          noticePeriod: this.state.noticePeriod,
          location: this.state.location,
          workingDays: this.state.workingDays,
          shiftTimings: this.state.shiftTime,
          numberOfOpenings: this.state.numberOfOpenings,
          salary: this.state.salary,
          skills: this.state.skils,
          qualification: this.state.qualification,
          benefits: this.state.benefits,
          hiringProcess: this.state.hiringProcess,
          description: this.state.description,
          metaData: {
            metaTitle: this.state.metaTitle,
            metaImageUrl: this.state.metaImageUrl,
            metaImageCaption: this.state.metaImageUrl,
            metaImageAlt: this.state.metaImageUrl,
            metaDescription: this.state.metaDescription,
            slug: this.state.slug,
            canonicalUrl: this.state.canonicalUrl,
          },
        };

        createJob(data)
          .then(() => {
            toast.success("Job Created Successfully.");
            this.props.router.navigate("/jobs");
          })
          .catch((err) => {
            toast.error(err.response.data.message);
            this.setState({ loading: false });
          });
      }
    }
  };

  updateJob = (event) => {
    if (event.target.name === "btn3") {
      this.props.router.navigate("/jobs");
    } else {
      if (this.validate()) {
        this.setState({ loading: true });

        let data = {
          jobTitle: this.state.title,
          department: this.state.department,
          position: this.state.position,
          type: this.state.type,
          experince: this.state.experience,
          noticePeriod: this.state.noticePeriod,
          location: this.state.location,
          workingDays: this.state.workingDays,
          shiftTimings: this.state.shiftTime,
          numberOfOpenings: this.state.numberOfOpenings,
          salary: this.state.salary,
          skills: this.state.skils,
          qualification: this.state.qualification,
          benefits: this.state.benefits,
          hiringProcess: this.state.hiringProcess,
          description: this.state.description,
          metaData: {
            metaTitle: this.state.metaTitle,
            metaImageUrl: this.state.metaImageUrl,
            metaDescription: this.state.metaDescription,
            slug: this.state.slug,
            canonicalUrl: this.state.canonicalUrl,
          },
        };

        updateJobById(data, this.props.router.params.id)
          .then(() => {
            toast.success("Job Updated Successfully.");
            this.props.router.navigate("/jobs");
          })
          .catch((err) => {
            toast.error(err.response.data.message);
            this.setState({ loading: false });
          });
      }
    }
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title={this.props?.title ? this.props.title : "Add New Job"}
            showBtn1={true}
            showBtn2={false}
            showBtn3={true}
            btn1type="filled"
            btn2type="outlined"
            btn3type="outlined_del"
            btn1Name="btn1"
            btn2Name="btn2"
            btn3Name="btn3"
            btn1Text="Save"
            btn2Text="Save as Draft"
            btn3Text="Cancel"
            onClickHandler={
              this.props.router.params.id ? this.updateJob : this.handleSubmit
            }
          />
          <ContentBody>
            <>
              <InputField
                isLabel={true}
                value={this.state.title}
                lable="Job Title"
                type="text"
                isRequired={true}
                placeholder="Job title"
                onChange={(event) => {
                  this.setState({ title: event.target.value });
                }}
              />
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <InputField
                  isLabel={true}
                  value={this.state.department}
                  lable="Department"
                  type="text"
                  isRequired={false}
                  placeholder="Department"
                  onChange={(event) => {
                    this.setState({ department: event.target.value });
                  }}
                />
                <InputField
                  isLabel={true}
                  value={this.state.position}
                  lable="Position"
                  type="text"
                  isRequired={false}
                  placeholder="Position"
                  onChange={(event) => {
                    this.setState({ position: event.target.value });
                  }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <InputField
                  isLabel={true}
                  value={this.state.type}
                  lable="Type"
                  type="text"
                  isRequired={false}
                  placeholder="Type"
                  onChange={(event) => {
                    this.setState({ type: event.target.value });
                  }}
                />
                <InputField
                  isLabel={true}
                  value={this.state.experience}
                  lable="Experience"
                  type="text"
                  isRequired={false}
                  placeholder="Experience"
                  onChange={(event) => {
                    this.setState({ experience: event.target.value });
                  }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <InputField
                  isLabel={true}
                  value={this.state.noticePeriod}
                  lable="Notice Period"
                  type="text"
                  isRequired={false}
                  placeholder="Notice period"
                  onChange={(event) => {
                    this.setState({ noticePeriod: event.target.value });
                  }}
                />
                <InputField
                  isLabel={true}
                  value={this.state.location}
                  lable="Location"
                  type="text"
                  isRequired={false}
                  placeholder="Location"
                  onChange={(event) => {
                    this.setState({ location: event.target.value });
                  }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <InputField
                  isLabel={true}
                  value={this.state.workingDays}
                  lable="Working Days"
                  type="number"
                  isRequired={false}
                  placeholder="Working days"
                  onChange={(event) => {
                    this.setState({ workingDays: event.target.value });
                  }}
                />
                <InputField
                  isLabel={true}
                  value={this.state.shiftTime}
                  lable="Shift Timings"
                  type="text"
                  isRequired={false}
                  placeholder="Shift timings"
                  onChange={(event) => {
                    this.setState({ shiftTime: event.target.value });
                  }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <InputField
                  isLabel={true}
                  value={this.state.numberOfOpenings}
                  lable="Number of Openings"
                  type="number"
                  isRequired={false}
                  placeholder="Number of openings"
                  onChange={(event) => {
                    this.setState({ numberOfOpenings: event.target.value });
                  }}
                />
                <InputField
                  isLabel={true}
                  value={this.state.salary}
                  lable="Salary"
                  type="text"
                  isRequired={false}
                  placeholder="Salary"
                  onChange={(event) => {
                    this.setState({ salary: event.target.value });
                  }}
                />
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                <div>
                  <InputField
                    type="text"
                    isLabel={true}
                    value={this.state.skillsText}
                    lable={"Skills (Press Enter to add)"}
                    isRequired={false}
                    placeholder={"Value"}
                    onChange={(e) => {
                      this.setState({ skillsText: e.target.value });
                    }}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        this.setState({
                          skils: [...this.state.skils, this.state.skillsText],
                          skillsText: "",
                        });
                      }
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {this.state.skils.map((tag, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            background: "var(--blue-light)",
                            color: "var(--blue-dark)",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {tag}
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              let temp = [...this.state.skils];
                              temp.splice(index, 1);
                              this.setState({ skils: temp });
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "0px",
                  marginTop: "20px",
                }}
              >
                <>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                    }}
                  >
                    Qualification
                  </p>
                  <TextEditor
                    content={this.state.qualification}
                    handleChange={(value, delta, source, editor) => {
                      this.setState({ qualification: value });
                    }}
                  />
                </>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "0px",
                  marginTop: "20px",
                }}
              >
                <>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                    }}
                  >
                    Benefits
                  </p>
                  <TextEditor
                    content={this.state.benefits}
                    handleChange={(value, delta, source, editor) => {
                      this.setState({ benefits: value });
                    }}
                  />
                </>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "0px",
                  marginTop: "20px",
                }}
              >
                <>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                    }}
                  >
                    Hiring Process
                  </p>
                  <TextEditor
                    content={this.state.hiringProcess}
                    handleChange={(value, delta, source, editor) => {
                      this.setState({ hiringProcess: value });
                    }}
                  />
                </>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "0px",
                  marginTop: "20px",
                }}
              >
                <>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                    }}
                  >
                    Description
                  </p>
                  <TextEditor
                    content={this.state.description}
                    handleChange={(value, delta, source, editor) => {
                      this.setState({ description: value });
                    }}
                  />
                </>
              </div>
              <div className="card grid" style={{ marginTop: "20px" }}>
                <h3>Meta Data</h3>
                <InputField
                  isLabel={true}
                  lable="Slug"
                  type="text"
                  value={this.state.slug}
                  onChange={(e) =>
                    this.setState({ slug: e.target.value.replace(" ", "-") })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Meta Title"
                  type="text"
                  value={this.state.metaTitle}
                  onChange={(e) => this.setState({ metaTitle: e.target.value })}
                />
                <InputField
                  isLabel={true}
                  lable="Meta Image Url"
                  type="text"
                  value={this.state.metaImageUrl}
                  onChange={(e) =>
                    this.setState({ metaImageUrl: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Canonical Url"
                  type="text"
                  value={this.state.canonicalUrl}
                  onChange={(e) =>
                    this.setState({ canonicalUrl: e.target.value })
                  }
                />
                <InputField
                  isLabel={true}
                  lable="Meta Description"
                  type="textarea"
                  value={this.state.metaDescription}
                  onChange={(e) =>
                    this.setState({ metaDescription: e.target.value })
                  }
                />
              </div>
            </>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateJob);
